<ion-content>
  <div id="greeting">
    <div id="greeting-header">
      Hey <span id="greeting-username">{{username}}</span> !
    </div>
    <div id="greeting-sub">What are you looking for?</div>
  </div>

  <ion-grid class="flex justify-center">
    <ion-row>
      <ion-col class="flex justify-end">
        <ion-card
          class="home-grid-item ion-activatable ripple-parent"
          routerLink="/daily-chat"
        >
          <ion-text fill="clear" class="font-medium text-black">
            Bizi Buzz
          </ion-text>
          <ion-ripple-effect></ion-ripple-effect>
          <ion-icon name="chatbubble-ellipses-outline" size="large"></ion-icon>
        </ion-card>
      </ion-col>

      <ion-col class="flex justify-end">
        <ion-card
          routerLink="/shop-products"
          class="home-grid-item ion-activatable ripple-parent"
        >
          <ion-text fill="clear" class="font-medium text-black">
            Marketplace
          </ion-text>
          <ion-ripple-effect></ion-ripple-effect>
          <ion-icon name="bag-outline" size="large"></ion-icon>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="flex justify-start">
        <ion-card
          class="home-grid-item ion-activatable ripple-parent"
          routerLink="/local-deals"
        >
          <ion-text fill="clear" class="font-medium text-black">
            Local Deals
          </ion-text>
          <ion-ripple-effect></ion-ripple-effect>
          <ion-icon name="pricetag-outline" size="large"></ion-icon>
        </ion-card>
      </ion-col>

      <ion-col class="flex">
        <ion-card
          class="home-grid-item ion-activatable ripple-parent"
          routerLink="/local-events"
        >
          <ion-text fill="clear" class="font-medium text-black">
            Local Events
          </ion-text>
          <ion-ripple-effect></ion-ripple-effect>
          <ion-icon name="today-outline" size="large"></ion-icon>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card
    class="home-grid-item ion-activatable ripple-parent mx-auto"
    routerLink="/my-profile"
  >
    <ion-text fill="clear" class="font-medium text-black">
      My Profile
    </ion-text>
    <ion-ripple-effect></ion-ripple-effect>
    <ion-icon name="person-outline" size="large"></ion-icon>
  </ion-card>

  <ion-col class="top-24 flex justify-center">
    <div class="flex flex-col items-center gap-1">
      <ion-button
        fill="outline" 
        color="Dark" 
        shape="round" 
        size="large"
        class="w-fit px-16"
        routerLink="/crisis-resource"
      >
        <ion-text fill="clear" class="font-medium text-black">
          Check in on Yourself
        </ion-text>  
      </ion-button>

      <ion-text fill="clear" style="text-align: center;" class="font-sm text-black ion-button-text">
        <i>
          A safe, anonymous tool for you
        </i>
      </ion-text>
    </div>
  </ion-col>
</ion-content>